import { useCallback } from 'react';
import { useWixPatternsContainer, useCollectionContext } from '../providers';
import { ModalState, ImportState, BackupFn, BulkUploadItemsFn } from '../state';
import { CreateExportAsyncJobRequest } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';
import { FiltersMap } from '../model';

export interface UseImportParams {
  fields: CreateExportAsyncJobRequest['fields'];
  bulkUploadItems: BulkUploadItemsFn;
  backup?: BackupFn;
  importModalState: ModalState;
  batchSize?: number;
}

export function useCreateImport<T = unknown, F extends FiltersMap = FiltersMap>(params: UseImportParams) {
  const { fields, bulkUploadItems, backup, importModalState, batchSize } = params;
  const { showToast, translate, errorHandler } = useWixPatternsContainer();
  const collection = useCollectionContext<T, F>();

  return useCallback(() => {
    return new ImportState({
      fields,
      bulkUploadItems,
      backup,
      collection,
      importModalState,
      batchSize,
      showToast,
      translate,
      errorHandler,
    });
  }, []);
}
